import React, {useEffect, useState} from "react";
import {communityService} from "../../../services/communityService/communityService";
import Loader from "../../../components/common/Loader";
import DiscussionsList from "./DiscussionsList";
import {Pagination} from "../../../components/Pagination/Pagination";
import {FiSearch} from "react-icons/fi";
import useDebounce from "../../../hooks/useDebounce";

const MasterClassDiscussions = () => {
    const [masterClassDiscussions, setMasterClassDiscussions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [requestPage, setRequestPage] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const debouncedSearchTerm = useDebounce(searchTerm, 750);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        getMasterClassDiscussions();
    }, [requestPage, debouncedSearchTerm]);

    useEffect(() => {
        setRequestPage(1);
    }, [debouncedSearchTerm]);

    const getMasterClassDiscussions = async () => {
        setIsLoading(true);
        try {
            const response = await communityService.getMasterClassDiscussions(12, requestPage, searchTerm);
            setMasterClassDiscussions(response.data.data);
            setCurrentPage(response.data.meta.current_page);
            setTotalPages(response.data.meta.last_page);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    const handlePageChange = (page) => {
        setRequestPage(page);
    };

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    return (
        <>
            <div className="container-fluid">
                {isLoading ? (
                    <Loader />
                ) : (
                    <>
                        <DiscussionsList
                            title="Speaker Discussions"
                            description={'Continue the conversation beyond the masterclass. These focused threads dive deeper into each course you’ve unlocked, offering a space to reflect, ask follow-up questions, and connect with others exploring the same topics. It’s your place to engage with content and each other on a richer level.'}
                            discussions={masterClassDiscussions}
                            navigateTo="/master-class/discussions/"
                            sideComponent={
                                <div className="search-container">
                                    <input onChange={handleSearch} value={searchTerm} placeholder="Search"
                                           className="search-input" autoFocus={true}/>
                                    <FiSearch className="search-icon"/>
                                </div>
                            }
                        />
                        <div className="mt-2">
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default MasterClassDiscussions;